import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Container } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { UserPlus, Loader2, AlertCircle } from "lucide-react";

export default function PostDonationAccount() {
  const { register, errMsg } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/organizer/dashboard", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#F3F4F6]">
      <Container className="flex min-h-[70vh] items-center justify-center py-14">
        <div className="w-full max-w-md rounded-2xl border border-ff-border bg-white p-8 shadow-sm">
          <div className="mb-1 flex items-center gap-2 text-ff-red"><UserPlus className="h-5 w-5" /><span className="text-xs font-bold uppercase tracking-wider">Optional</span></div>
          <h1 className="font-heading text-2xl font-bold text-ff-blue">Save your donation history</h1>
          <p className="mt-2 text-sm text-ff-dark">Create a free account to track your donations and receipts. You can skip this.</p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="post-donation-form">
            {error && <Alert variant="destructive"><AlertCircle className="h-4 w-4" /><AlertDescription>{error}</AlertDescription></Alert>}
            <div>
              <Label htmlFor="pd-name">Name</Label>
              <Input id="pd-name" required data-testid="pd-name" value={form.name} onChange={set("name")} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="pd-email">Email</Label>
              <Input id="pd-email" type="email" required data-testid="pd-email" value={form.email} onChange={set("email")} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="pd-password">Password</Label>
              <Input id="pd-password" type="password" required data-testid="pd-password" value={form.password} onChange={set("password")} className="mt-1.5" placeholder="At least 8 characters" />
            </div>
            <Button type="submit" disabled={loading} data-testid="pd-submit"
              className="w-full bg-ff-action font-semibold text-white hover:bg-ff-actionDark">
              {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Creating</> : "Create Account"}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/" data-testid="pd-skip" className="text-sm font-semibold text-ff-medium hover:text-ff-red">No thanks, skip</Link>
          </div>
        </div>
      </Container>
    </div>
  );
}
